import { Entity, SoftDeletable } from './entity';

/**
 * The kind of media an asset type carries. Owned here because the asset type is
 * what defines it; a method type's kind is the kind of its asset type, so the
 * protocols layer aliases this rather than redeclaring it.
 */
export type AssetTypeKind = 'image' | 'video' | 'text' | 'audio';

export interface AssetTypeAttributes extends Entity, SoftDeletable {
  name: string;
  description?: string;
  type?: AssetTypeKind;
  version?: string;
  deviceTypeIds?: string[];
}

export class AssetType {
  constructor(private attributes: AssetTypeAttributes) {}

  public get id(): string {
    return this.attributes.id;
  }

  public get name(): string {
    return this.attributes.name;
  }

  public get description(): string {
    return this.attributes.description;
  }

  public get type(): AssetTypeKind {
    return this.attributes.type;
  }

  public get version(): string {
    return this.attributes.version;
  }

  public get deviceTypeIds(): ReadonlyArray<string> {
    return this.attributes.deviceTypeIds ?? [];
  }

  public get createdAt(): Date {
    return this.attributes.createdAt;
  }

  public get updatedAt(): Date {
    return this.attributes.updatedAt;
  }

  public get deletedAt(): Date {
    return this.attributes.deletedAt;
  }
}
